<template>
  <div class="p-fluid">
    <div class="p-col-12 p-lg-12">
      <CustomBreadcrumb :items="items_bread_crumb"  />
      <div class="card card-w-title">
        <div class="row manager-title-row">
          <div class="p-col-4 manager-title-custom">{{ title }}</div>
        </div>
        <!-- <div class="note">(*) Nội dung không được bỏ trống</div> -->
        <formEdit :key="componentKey" :mode="mode" @back="backToList" @save="saveData" :triggerSave.sync="triggerSave"
          :model="models" />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import DataServices from '@/core/DataServices'
import formEdit from './add'
import gql from "graphql-tag";
export default {
  components: {
    formEdit
  },
  data() {
    return {
      items_bread_crumb: [
        { label: 'Voucher', to: '/admin/list-voucher' },
        { label: '' }
      ],
      users: null,
      validationErrors: [],
      title: "Create A New Voucher",
      mode: 'add',
      models: {},
      componentKey: 0,
      accountID: '',
      page_transaction: null,
      active_check: true,
      users_clubs_id: '',
      time_zone_local: moment.tz.guess(true),
      triggerSave: false
    }
  },
  async mounted() {
    console.log("this.$route.name:", this.$route.query.page_transaction);
    this.mode = this.$route.name === 'edit' ? 'edit' : this.mode;
    this.title = this.mode === 'edit' ? 'Edit' : this.title;
    this.items_bread_crumb[1].label = this.title;
    if (this.$route.params.id !== undefined) await this.getData(this.$route.params.id);
    if (!this.$commonFuction.isEmpty(this.$route.query)) {
      if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)) {
        this.page_transaction = this.$route.query.page_transaction;
      }
    }
    //check quyền
    var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_VOUCHER);
    if (this.mode == 'edit') {
      if (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0) {
        this.$router.push({ path: this.$constants.URL_ERR.FOBIDDEN });
      }
    } else {
      if (arr_role.indexOf(this.$constants.ROLE.ADD) < 0) {
        this.$router.push({ path: this.$constants.URL_ERR.FOBIDDEN });
      }
    }
  },
  methods: {
    backToList() {
      this.$router.push({ path: '/admin/list-voucher' });
    },
    UpdateActive(key) {
      // console.log("key",key)
      var uid = this.$route.params.id;
      this.$commonFuction.is_loading(true);
      if (key == 'lock') {
        this.active_check = false
      } else {
        this.active_check = true
      }

      let variables = {
        'data_update': {
          'active': this.active_check
        },
        'where_key': {
          'id': { '_eq': this.$route.params.id }
        }
      };
      var that = this;
      this.$apollo.mutate({
        mutation: DataServices.updateData('users'),
        variables: variables
      }).then(async (res) => {
        console.log('Success', res);
        if (key == 'lock') {
          var query_t = `mutation {
            delete_jwt_token(where: { uid: {_eq: "${uid}"}}) {
              returning {
                id
              }
            }
          }`
          await that.$apollo.mutate({
            mutation: gql(query_t),
          })
        }
        that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Save data successfully', life: 3000 })
      })
      this.$commonFuction.is_loading(false);
      // console.log("this.$route.params.id",this.$route.params.id)
    },
    async saveData(params) {
      let objects = {};
      let objects_list_category = {};
      let objects_list_loyalty = {};
      let objects_list_user_apply_voucher = {};
      // type_condition 1 all 2 rent 3 buy
      if (params.type_condition === "1" || params.type_condition === "3") {
        objects.duration = null;
        objects_list_category.list_category = [];
      } else if (params.type_condition === "2") {
        objects.duration = params.duration;
        objects_list_category.list_category = params.list_category;
      }

      if (params.type_apply_customer === "1") {
        objects_list_loyalty.list_loyalty = [];
        objects_list_user_apply_voucher.list_user_apply_voucher = [];
      } else if (params.type_apply_customer === "2") {
        objects_list_user_apply_voucher.list_user_apply_voucher = [];
        objects_list_loyalty.list_loyalty = params.list_loyalty;
      } else if (params.type_apply_customer === "3") {
        objects_list_loyalty.list_loyalty = [];
        objects_list_user_apply_voucher.list_user_apply_voucher = params.list_user_apply_voucher;
      }


      if (params.type_discount == 1) {
        objects.max_discount_amount = params.max_discount_amount;
      } else if (params.type_discount == 2) {
        objects.max_discount_amount = null;
      }
      objects = {
        ...objects,
        name: params?.name ?? '',
        code: params?.code ?? '',
        short_description: params?.short_description ?? '',
        valid_end: params?.valid_end ? moment(params.valid_end, "DD/MM/YYYY").format("YYYY-MM-DD")  : null,
        valid_start: params?.valid_start ? moment(params.valid_start, "DD/MM/YYYY").format("YYYY-MM-DD")  : null,
        valid_duration: params?.valid_duration ?? null,
        amount: params?.amount ?? 0,
        type_discount: params?.type_discount ?? null,
        type_condition: params?.type_condition ?? null,
        type_apply_customer: params?.type_apply_customer ?? null,
        active: params?.active ?? true, 
        limit_use : params?.limit_use ?? false,
        updated_at: moment.tz(new Date(), this.time_zone_local),
        updated_by: this.$store.getters.user
      }
      var listDelVehicleCategory = params.listDelVehicleCategory;
      console.log('2222222222222222222', objects)
      if (objects.valid_start > objects.valid_end) {
        // gán valid_end = valid_start
        objects.valid_end = objects.valid_start;
      }

      this.triggerSave = false;
      if (this.mode == 'add') {
        console.log('a');
        
        objects.created_at = moment.tz(new Date(), this.time_zone_local);
        objects.created_by = this.$store.getters.user;
        await this.$apollo.mutate({
          mutation: DataServices.insertData('voucher'),
          variables: {
            objects: objects
          }
        }).then(async (res) => {
          if (res.data[Object.keys(res.data)].affected_rows) {
            var returningVoucher = res.data[Object.keys(res.data)].returning[0];
            if (objects_list_category.list_category.length > 0) {
              for (let index = 0; index < objects_list_category.list_category.length; index++) {
                await this.$apollo.mutate({
                  mutation: DataServices.insertData('voucher_vehicle_category'),
                  variables: {
                    objects: {
                      voucher_id: returningVoucher.id ?? null,
                      vehicle_category_id: objects_list_category.list_category[index],
                      created_at: moment.tz(new Date(), this.time_zone_local),
                      created_by: this.$store.getters.user,
                    }
                  }
                })
              }

            }
            if (objects_list_loyalty.list_loyalty.length > 0) {
              for (let index = 0; index < objects_list_loyalty.list_loyalty.length; index++) {
                await this.$apollo.mutate({
                  mutation: DataServices.insertData('voucher_loyalty'),
                  variables: {
                    objects: {
                      voucher_id: returningVoucher.id ?? null,
                      loyalty_id: objects_list_loyalty.list_loyalty[index],
                      created_at: moment.tz(new Date(), this.time_zone_local),
                      created_by: this.$store.getters.user,
                    }
                  }
                })
              }

            }
            if (objects_list_user_apply_voucher.list_user_apply_voucher.length > 0) {
              var list_customer_id = [];
              for (let index = 0; index < objects_list_user_apply_voucher.list_user_apply_voucher.length; index++) {
                list_customer_id.push(objects_list_user_apply_voucher.list_user_apply_voucher[index]);
                await this.$apollo.mutate({
                  mutation: DataServices.insertData('voucher_customer'),
                  variables: {
                    objects: {
                      voucher_id: returningVoucher.id ?? null,
                      uid: objects_list_user_apply_voucher.list_user_apply_voucher[index],
                      created_at: moment.tz(new Date(), this.time_zone_local),
                      created_by: this.$store.getters.user,
                      status: '',
                    }
                  }
                })
              }
            
           var params_noti =null;
           if(list_customer_id.length >0){
            params_noti ={
                title:"",
                content:"",
                short_content:`Congrats! You've got a new promo code from [${params?.name}]. Check it out! `,
                short_content_noti:`Congrats! You've got a new promo code from [${params?.name}]. Check it out! `,
                type:null,
                action_key:this.$constants.ACTION_KEY_NOTI.MY_VOUCHER,
                uid:null,
                multi_uid:list_customer_id,
                object_id:null,
                is_admin:false,
                key_noti:1,//
              }
               await this.$CoreService.sendNoti(params_noti);
           }

            }
            this.redirectEdit();
          }
        }).catch(async error => {
          console.log('error', error);
          this.$toast.add({
            severity: 'error',
            summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
            detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
            life: 3000
          });
          this.$commonFuction.is_loading(false);
        });
      } else {
        // var user_id = this.$route.params.id;
        let variables = {
          'data_update': objects,
          'where_key': {
            'id': { '_eq': this.models.id }
          }
        }
        await this.$apollo.mutate({
          mutation: DataServices.updateData('voucher'),
          variables: variables
        }).then(async (res) => {
          // console.log("res",res);
          if (res.data[Object.keys(res.data)].affected_rows) {
            var returningVoucher = res.data[Object.keys(res.data)].returning[0];
            if (params.type_condition === "1" || params.type_condition === "3") {
              await this.$apollo.mutate({
                mutation: DataServices.deleteData('voucher_vehicle_category'),
                variables: {
                  where_key: {
                    voucher_id: { _eq: this.models.id }
                  }
                }
              })
              
            }
            if (listDelVehicleCategory.length > 0) {
              for (let index = 0; index < listDelVehicleCategory.length; index++) {
                await this.$apollo.mutate({
                  mutation: DataServices.deleteData('voucher_vehicle_category'),
                  variables: {
                    where_key: {
                      voucher_id: { _eq: this.models.id },
                      vehicle_category_id: { _eq: listDelVehicleCategory[index] }
                    }
                  }
                })
              }
              
            }
            if (objects_list_category.list_category.length > 0) {
              await this.$apollo.mutate({
                mutation: DataServices.deleteData('voucher_vehicle_category'),
                variables: {
                  where_key: {
                    voucher_id: { _eq: this.models.id }
                  }
                }
              })

              // xóa các list_category cũ đi rồi thêm list mới.
              for (let index = 0; index < objects_list_category.list_category.length; index++) {
                await this.$apollo.mutate({
                  mutation: DataServices.insertData('voucher_vehicle_category'),
                  variables: {
                    objects: {
                      voucher_id: returningVoucher.id ?? null,
                      vehicle_category_id: objects_list_category.list_category[index],
                      created_at: moment.tz(new Date(), this.time_zone_local),
                      created_by: this.$store.getters.user,
                    }
                  }
                })
              }

            }
            if (params.type_apply_customer === "1") {
              await this.$apollo.mutate({
                mutation: DataServices.deleteData('voucher_loyalty'),
                variables: {
                  where_key: {
                    voucher_id: { _eq: this.models.id }
                  }
                }
              })
              await this.$apollo.mutate({
                mutation: DataServices.deleteData('voucher_customer'),
                variables: {
                  where_key: {
                    voucher_id: { _eq: this.models.id }
                  }
                }
              })
            } else if (params.type_apply_customer === "2") {
              await this.$apollo.mutate({
                mutation: DataServices.deleteData('voucher_customer'),
                variables: {
                  where_key: {
                    voucher_id: { _eq: this.models.id }
                  }
                }
              })
            } else if (params.type_apply_customer === "3") {
              await this.$apollo.mutate({
                mutation: DataServices.deleteData('voucher_loyalty'),
                variables: {
                  where_key: {
                    voucher_id: { _eq: this.models.id }
                  }
                }
              })
              
            }

            if (objects_list_loyalty.list_loyalty.length > 0) {
              await this.$apollo.mutate({
                mutation: DataServices.deleteData('voucher_loyalty'),
                variables: {
                  where_key: {
                    voucher_id: { _eq: this.models.id }
                  }
                }
              })
              for (let index = 0; index < objects_list_loyalty.list_loyalty.length; index++) {
                await this.$apollo.mutate({
                  mutation: DataServices.insertData('voucher_loyalty'),
                  variables: {
                    objects: {
                      voucher_id: returningVoucher.id ?? null,
                      loyalty_id: objects_list_loyalty.list_loyalty[index],
                      created_at: moment.tz(new Date(), this.time_zone_local),
                      created_by: this.$store.getters.user,
                    }
                  }
                })
              }

            }
            if (objects_list_user_apply_voucher.list_user_apply_voucher.length > 0) {
              // await this.$apollo.mutate({
              //   mutation: DataServices.deleteData('voucher_customer'),
              //   variables: {
              //     where_key: {
              //       voucher_id: { _eq: this.models.id }
              //     }
              //   }
              // })
              for (let index = 0; index < objects_list_user_apply_voucher.list_user_apply_voucher.length; index++) {
                await this.$apollo.mutate({
                  mutation: DataServices.insertData('voucher_customer'),
                  variables: {
                    objects: {
                      voucher_id: returningVoucher.id ?? null,
                      uid: objects_list_user_apply_voucher.list_user_apply_voucher[index],
                      created_at: moment.tz(new Date(), this.time_zone_local),
                      created_by: this.$store.getters.user,
                      status: '',
                    }
                  }
                })
              }

            }
            this.redirectEdit();
          }
        }).catch(async error => {
          console.log('error', error);
          this.$toast.add({
            severity: 'error',
            summary: this.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
            detail: this.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN,
            life: 3000
          });
          this.$commonFuction.is_loading(false);
        });
      }
      this.$commonFuction.is_loading(false);
    },
    async redirectEdit() {
      var that = this;
      var router_back = { path: '/admin/list-voucher' };
      console.log('router_back', router_back)
      that.$commonFuction.is_loading(false);
      if (that.mode == 'add') {
        that.$router.push(router_back);
      } else {
        if (!that.$commonFuction.isEmpty(router_back)) {
          // that.page_transaction = ""+that.page_transaction
          router_back.query = { page_transaction: that.page_transaction.toString() };
        }
        that.$router.push(router_back);
      }
      that.$toast.add({ severity: 'success', summary: 'Success', detail: 'Save data successfully', life: 3000 })
    },
    async getData(id) {
      var { data } = await this.$apollo.query({
        query: DataServices.getList('voucher'),
        variables: {
          where_key: {
            id: { '_eq': id }
          }
        },
        fetchPolicy: "network-only"
      })
      console.log("datadata:", data);
      var model = data[Object.keys(data)];
      if (model.length > 0) {
        this.models = model[0];
      }
      this.componentKey++;
    },
  },
  apollo: {

  }
}
</script>

<style lang="scss">
.manager-title-custom {
  color: #1D3118;
  font-size: 24px;
  /* margin-bottom: 16px; */
  padding-bottom: 10px;
  /* border-bottom: 1px solid #EEEEEE; */
  font-weight: 700;
  margin-left: 20px;
}

.p-inputnumber-buttons-stacked {
  .p-inputnumber-button-group {
    .p-button.p-button-icon-only {
      padding: 0 !important;
    }
  }
}

.note {
  letter-spacing: 0px;
  color: #707070;
  margin-bottom: 24px;
  padding-top: 10px;
}

.p-formgrid {
  margin: 0;

  .p-panel-header {
    color: #000000;
    font-size: 18px;
    font-weight: bold;
    background: #EEEEEE;
  }

  .p-card-field {
    padding: 24px;

    .p-field {
      .p-col-fixed {
        width: 300px;
        display: inline-block !important;
        margin: 0;
      }

      .p-col-width {
        width: 500px !important;
        border-radius: 5px;

        &.disabled {
          background: #EEEEEE;
          border: 0 none;
          padding: 8px 10px;
        }

        .file-select {
          margin: 0;

          input[type="file"] {
            display: none;
          }

          .select-button {
            display: inline-block;
            cursor: pointer;
            background: transparent;
            border-radius: 5px;
            color: #000000;
            font-size: 13px;
            padding: 3px 16px;
            border: 1px solid #B4B4B4;
          }
        }

        &.pac-target-input {
          height: 80px;
          word-break: break-all;
          overflow-wrap: break-word;
          resize: none;
        }
      }

      .box-images {
        margin: 0;
        margin-top: 10px;
        position: relative;

        .item-img {
          width: 150px;
          height: 150px;
          margin-right: 8px;
          margin-bottom: 8px;
          display: inline-flex;
          position: relative;

          img {
            max-width: 100%;
            height: auto;
            margin: 0 auto;
            object-fit: contain;
            padding: 5px;
          }

          .button-clear {
            border-radius: 10px;
            width: 24px;
            height: 24px;
            background: #F5564E;
            float: right;
            cursor: pointer;
            position: absolute;
            right: 0px;

            img {
              vertical-align: top;
            }
          }
        }
      }

      .p-invalid {
        display: block;
      }
    }
  }

  .fixed-bottom-toolbar {
    background: transparent;
    border: 0 none;
    margin-top: 22px;
    border-top: 1px solid #B4B4B4;
    padding: 0;
    padding-top: 30px;

    .p-button {
      width: auto;
      margin-right: 8px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
}

.manager-title-row {
  border-bottom: 1px solid #EEEEEE;
}

.p-toolbar-group-right {
  flex-basis: 30%;
}

.p-button-warning.p-button {
  margin: 0 10px;
}
</style>